<template>
  <footer class="modern-footer">

    <div class="footer-text">
      © 2017-{{ year }} Fastana Logistik Indonesia
    </div>

    <div class="footer-text ms-3">
      Version 1.0.0
    </div>

  </footer>
</template>

<script>
export default {
  name: "FooterComponent",

  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
